<template>
  <div>
    <div class="continus-tip">
      已连续打卡 <span>{{max_cont}}</span> 天
    </div>
    <div class="badge-list">
        <div class="btn bage-title">我的徽章</div>
        <div class="bage bage1 " :class="{active:max_cont >= 7 }"></div>
        <div class="bage bage2 " :class="{active:max_cont >= 14 }"></div>
        <div class="bage bage3 " :class="{active:max_cont >= 21 }"></div>
        <div class="bage bage4 " :class="{active:max_cont >= 30 }"></div>
    </div>
    <div class="c-record-list" >
      <div class="c-record-title"> 打卡记录</div>
      <div class="c-continuous-list">
        <div
          v-for="(item, index) in table"
          class="c-continuous-item"
          :key="index"
        >
          <div class="c-item-icon">
            <div class="c-item-icon-inner" :class="{ checked: !!item.check }">
              {{ index + 1 }}
              <svg id="gou" t="1567155373715" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1978" width="16" height="16" fill="#fff">
                <path
                  d="M511.974401 0c-282.75527 0-511.974401 229.219131-511.974401 511.974401 0 282.757318 229.219131 511.974401 511.974401 511.974401 282.757318 0 511.974401-229.217083 511.974401-511.974401C1023.948803 229.219131 794.729672 0 511.974401 0zM805.63063 379.174385 474.510162 710.296901c0 0-0.004096 0.004096-0.010239 0.010239-15.265029 15.269125-38.541433 17.652877-56.31104 7.157402-3.290971-1.945503-6.393536-4.333351-9.219635-7.157402-0.002048-0.004096-0.006144-0.006144-0.006144-0.006144l-190.642884-190.642884c-18.095223-18.095223-18.095223-47.4375 0-65.536819 18.095223-18.095223 47.4375-18.095223 65.532723 0l157.884714 157.884714 298.362298-298.362298c18.097271-18.095223 47.439548-18.095223 65.534771 0C823.725854 331.738933 823.725854 361.079162 805.63063 379.174385z"
                  p-id="1979"
                  fill="#f4ea2a"
                ></path>
              </svg>
            </div>
          </div>
          <div class="c-item-day">{{ calcDate(startDate, index) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DAY_IN_SECONED,START_DATE,DURATION } from "./config";
import page from '@/components/page'
export default {
  components:{page},
  data() {
    return {
      startDate:START_DATE,
      table: [
        { check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },
        { check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },
        { check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },
        { check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },{ check: 0 },
        { check: 0 },{ check: 0 },{ check: 0 },
      ],
    };
  },
  props: {
    records:{
      type: Array,
      default: function () {
        return []
      }
    },
    max_recent_cont:{},
    max_cont:{}
  },
  created(){
    this.calcRecords(this.records)
  },
  methods: {
    calcDate(date, index) {
      let newDate = new Date(date.getTime() + DAY_IN_SECONED * index);
      return newDate.getMonth() + 1 + "." + newDate.getDate() + "";
    },
    calcRecords(checkedList){
        checkedList.map((item) => {
          item = ("" + item).split("");
          item.splice(4, 0, "/");
          item.splice(7, 0, "/");
          item = item.join("");
          let itemDate = new Date(item);
          let diff = itemDate - this.startDate;
          if (diff >= 0 && diff < DURATION * DAY_IN_SECONED) {
            let diffDay = parseInt(diff / DAY_IN_SECONED);
            this.table.splice(diffDay, 1, { check: 1 });
          }
        });
    }
  },
  watch:{
    records:{
      deep:true,
      handler(newVal,oldVal){
        console.log(newVal)
        newVal && calcRecords(newVal)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.continus-tip{
  font-size: 14px;
  color: #fff;
  margin-bottom: 3px;
  text-align: left;
  span{
    color: #EBD275;
    font-weight: bold;
  }
}
.badge-list{
    padding: 20px 10px;
    background-color: #fff;
    // height: 150px;
    margin-bottom: 20px;
    border-radius: 5px;
    position: relative;

    .bage-title{
        position: absolute;
        top: -20px;
        right: 10px;
    }

    display: flex;
    justify-content: space-between;
    // align-content: space-around;
    .bage{
      width: 20%;
      &::before{
        content: '';
        display: block;
        padding-bottom: 100%;
      }
      background-size: 100% auto;
      background-position: center center;
      background-repeat: no-repeat;
      &.bage1{
        background-size: 90% auto;
        background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936376778060003.png');
        &.active{
           background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936371385014129.png');
        }
      }
      &.bage2{
        background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936354869093607.png');
         &.active{
           background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936349678063487.png');
        }
      }
      &.bage3{
        background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936365459022102.png');
        &.active{
           background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936360932054993.png');
        }
      }
      &.bage4{
        background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936345394058856.png');
        &.active{
           background-image: url('https://cbgccdn.thecover.cn/@/images/20210525/1621936340951044658.png');
        }
      }
    }
}
.c-record-list {
  padding: 10px;
  background-color: #fff;
  border-radius: 5px;
  .c-record-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5;
    color: #111111;
    margin-bottom: 12px;
  }
}
.c-continuous-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  // height: 200px;
  overflow: hidden;
  position: relative;
  //padding-bottom: 30px;
  &.all {
    height: auto;
  }
  .c-continuous-tip {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: linear-gradient(transparent 0, #f9f9f9 60%, #f9f9f9 100%);
    color: #5385a8;
    padding-top: 20px;
  }

  .c-continuous-item {
    flex: 0 0 14%;
    list-style: none;
    /*text-align: center;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    .c-item-icon {
      width: 70%;
      position: relative;
      &:before {
        display: block;
        content: "";
        width: 100%;
        padding-bottom: 100%;
      }
      .c-item-icon-inner {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border-radius: 50%;
        background-color: #ccc;
        box-shadow: 1px 1px 12px #ddd;
        font-size: 12px;
        #gou {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 40%;
          height: 40%;
          display: none;
        }
        &.checked {
          background: #910D0B;
          color: white;
          #gou {
            display: block;
          }
        }
      }
    }
    .c-item-day {
      font-size: 10px;
      margin-top: 3px;
    }
  }
}
</style>